/**
 * Functional wrapper over Object.values that provides automatic type inference.
 * @param obj The object to extract values from
 * @returns An array of values from the object
 */
export const values = (obj) => Object.values(obj);
